import { jsx as _jsx } from "react/jsx-runtime";
import GenericFilter from '../GenericFilter';
const SensorTypeFilter = ({ setFilter, sensorTypes, selectedSensorTypes, disabled, }) => {
    return (_jsx(GenericFilter, { title: "Sensor Type", setFilter: setFilter, items: sensorTypes, selectedItems: selectedSensorTypes, disabled: disabled }, void 0));
};
export default SensorTypeFilter;
